
<template>
  <div>
    <!-- Header -->
    <div class="header bg-blue py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">
                Please create an account or log in!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <amplify-authenticator username-alias="email">
            <amplify-sign-in
              slot="sign-in"
               hide-sign-up="false"
              handleAuthStateChange="{handleLogIn}"
            >
            <div slot="secondary-footer-content">Need an account? <a href="https://carepoint.pharmacy/providerportal/">Click here!</a></div>
            </amplify-sign-in>
          </amplify-authenticator>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
export default {
  data() {
    return {
      formFields: [
        {
          type: "email",
          label: "Email Address",
          placeholder: "Email",
          required: true
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Password",
          required: true
        },
        {
          type: "name",
          label: "Full Name",
          placeholder: "Full Name",
          required: true
        },
        {
          type: "phone_number",
          label: "Phone Number",
          placeholder: "(###) ###-####",
          required: true
        }
      ],
      model: {
        email: "",
        password: "",
        rememberMe: false
      }
    };
  },
  methods: {
    onSubmit() {
      // this will be called only after form is valid. You can do api call here to login
    }
  }
};
</script>
